import { z } from 'zod';

export const schemaBonitaetsRechnung = z.object({
    ausgaben: z
        .object({
            positions: z
                .array(
                    z.object({
                        label: z.string().optional(),
                        value: z.string().optional(),
                    }),
                )
                .optional(),
            total: z.string().optional(),
        })
        .optional(),
    einnahmen: z
        .object({
            positions: z
                .array(
                    z.object({
                        label: z.string().optional(),
                        value: z.string().optional(),
                    }),
                )
                .optional(),
            total: z.string().optional(),
        })
        .optional(),
    total: z.string().optional(),
});

export type SchemaBonitaetsRechnung = z.infer<typeof schemaBonitaetsRechnung>;
